module.exports = __webpack_public_path__ + "static/media/72.09b8d59.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/72.wav
// module id = irPf
// module chunks = 0